import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-sedes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './modal-sedes.component.html',
  styleUrl: './modal-sedes.component.scss'
})
export class ModalSedesComponent {
  sedes = []
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalSedesComponent>

  ) {
    this.sedes = data;
  }

  url(item) {
    window.open(item.redirect, '_blank');
  }

  close() {
    this.dialogRef.close();
  }
}
